var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay overlay--orange"},[_c('div',{staticClass:"content"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('start', true)}}},[_vm._v("Start")])])])}
var staticRenderFns = []

export { render, staticRenderFns }